import {times} from 'lodash';
import React from 'react';
import LoadingCard from 'src/components/CollegeSearch/LoadingCard';
import PropTypes from 'prop-types';

function Row(props) {
  return (
    <div className="college-search-loading-recommendation">
      <div className="college-search-loading-recommendation-header">
        <div className="college-search-loading-text medium shimmer" />
        <div className="college-search-loading-text small shimmer" />
      </div>
      <div className="college-search-loading-recommendation-cards">
        {times(props.cardCount || 6, (key) => (
          <LoadingCard key={key} />
        ))}
      </div>
    </div>
  );
}

Row.propTypes = {
  cardCount: PropTypes.number,
};

export const LoadingRecommendationRow = (props) => (
  <section className="college-search-loading">
    {times(props.rowCount || 2, (index) => (
      <Row cardCount={props.cardCount} key={index} />
    ))}
  </section>
);

LoadingRecommendationRow.propTypes = {
  rowCount: PropTypes.number,
  cardCount: PropTypes.number,
};
